import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useReveal from "./hooks/useReveal";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TickerBar from "./components/TickerBar";
import LiveResults from "./components/LiveResults";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import BuildSoftware from "./components/BuildSoftware";
import Pricing from "./components/Pricing";
import Terms from "./components/Terms";
import Contact from "./components/Contact";
import Promo from "./components/Promo";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import AdminLeads from "./components/AdminLeads";

function Landing() {
  useReveal();
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <TickerBar />
      <LiveResults />
      <Features />
      <Testimonials />
      <BuildSoftware />
      <Pricing />
      <Terms />
      <Contact />
      <Promo />
      <FAQ />
      <Footer />
      <FloatingButtons />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminLeads />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
